/**
 * Routes that render without a session, by design.
 *
 * One list, because several places ask the same question for different reasons - Main
 * skips its session gate, InactivityHandler skips arming the logout timer - and a list
 * that drifts between them reintroduces exactly the bugs it was written to prevent.
 *
 * Mirrors adib-frontend2's src/utils/authPaths.ts; the two apps share one backend
 * identity (see utils/dccLogin), so they must agree on where a visitor can be anonymous.
 */

/**
 * Pages that render WITHOUT the app chrome - no sidebar, header or breadcrumb.
 *
 * '/compliance/login' is the legacy URL, still reachable from old links and redirected to
 * '/login'. '/trust/*' is the public Trust Center: regulators, partners and insurers open
 * it directly and should see a clean, self-contained page.
 */
export function isLoginPath(pathname: string): boolean {
  return (
    pathname === '/login' ||
    pathname === '/register' ||
    pathname === '/compliance/login' ||
    pathname.startsWith('/trust/') ||
    // Financial Crime: the due diligence questionnaire a counterparty answers by its link, without an account
    pathname.startsWith('/q/')
  );
}

/**
 * Pages that render without a session at all. A superset of isLoginPath: nothing here may
 * be gated on /auth/me, and nothing here may arm a session timer, because there is no
 * session to warn about or end.
 */
export function isPublicPath(pathname: string): boolean {
  return (
    isLoginPath(pathname) ||
    pathname === '/logout-clear' ||
    pathname.startsWith('/error')
  );
}
